import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Sparkles, Globe, Star, Clock } from 'lucide-react';
import './WhyChorullaPalli.scss';

const WhyChorullaPalli = () => {
    const navigate = useNavigate();

    const features = [
        {
            icon: MapPin,
            title: 'Curated Guides',
            description: 'Handpicked mosques offering Iftar meals for every district in Kerala',
            color: '#ef4444',
            bgColor: '#fef2f2'
        },
        {
            icon: Sparkles,
            title: 'Clean Design',
            description: 'Distraction-free experience to help you find mosques faster',
            color: '#3b82f6',
            bgColor: '#eff6ff'
        },
        {
            icon: Globe,
            title: 'Global Coverage',
            description: 'Up-to-date information on mosques across all 14 districts of Kerala',
            color: '#8b5cf6',
            bgColor: '#f5f3ff'
        },
        {
            icon: Star,
            title: 'Real Reviews',
            description: 'Authentic ratings and comments from community members to guide your decisions',
            color: '#2d7a4a',
            bgColor: '#fffbeb'
        }
    ];

    const handleExploreClick = () => {
        // Navigate to show all mosques - we'll use a special route or state
        // For now, navigate to home with a flag to show all mosques
        navigate('/?explore=all');
    };

    return (
        <section className="why-chorulla-palli">
            <div className="why-chorulla-palli__container">
                <div className="why-chorulla-palli__header">
                    <h2 className="why-chorulla-palli__title">Why Chorulla Palli</h2>
                    <p className="why-chorulla-palli__subtitle">
                        Your trusted guide to finding mosques offering Iftar meals during Ramadan
                    </p>
                </div>

                <div className="why-chorulla-palli__features">
                    {features.map((feature, index) => {
                        const IconComponent = feature.icon;
                        return (
                            <div
                                key={feature.title}
                                className="why-chorulla-palli__feature-card"
                                style={{ 
                                    animationDelay: `${index * 0.1}s`,
                                    '--feature-color': feature.color,
                                    '--feature-bg': feature.bgColor
                                }}
                            >
                                <div className="why-chorulla-palli__feature-icon">
                                    <IconComponent size={24} />
                                </div>
                                <h3 className="why-chorulla-palli__feature-title">
                                    {feature.title}
                                </h3>
                                <p className="why-chorulla-palli__feature-description">
                                    {feature.description}
                                </p>
                            </div>
                        );
                    })}
                </div>

                <div className="why-chorulla-palli__mission">
                    <div className="why-chorulla-palli__mission-content">
                        <Clock className="why-chorulla-palli__mission-icon" size={32} />
                        <h3 className="why-chorulla-palli__mission-title">Our Mission</h3>
                        <p className="why-chorulla-palli__mission-text">
                            To connect believers with mosques offering Iftar meals during the blessed month of Ramadan. 
                            We believe in the power of community and the spirit of sharing. Our platform helps you discover 
                            nearby mosques, read authentic reviews, and contribute to building a comprehensive guide for 
                            the entire community.
                        </p>
                        <button 
                            className="why-chorulla-palli__explore-btn"
                            onClick={handleExploreClick}
                        >
                            Explore All Mosques
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChorullaPalli;
